'use strict';

export default function SpinWidget({ 
    value, 
    onChange, 
    maxValue = 10, 
    minValue = 0, 
    error, 
    className, 
    errorClass = 'error',
}) {

    function handleChange(v) {
        onChange(Math.min(maxValue, Math.max(minValue, value + v)))
    }

    return <div className={cn(className, error && errorClass)}>
        <div className={cn('search-spinner', value > 0 && 'changed')}>
            <i className="icon-people"></i>
            <input type="text" className="search-spinner__input" value={value} readOnly/>
            <span>
                <a className="search-spinner__down" onClick={() => handleChange(-1)}></a>
                <a className="search-spinner__up" onClick={() => handleChange(1)}></a>
            </span>
        </div>
    </div>
}
